import React from "react";
import { connect } from "react-redux";
import ScheduleTable from "./components/ScheduleTable";

const EmployeeSchedule = ({employeeId}) => {
	
	
	return (
	    <div>
			<div className="grid h-full grid-cols-1 gap-4">
				<ScheduleTable employeeId={employeeId} />
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.employee.employeeScheduleList?.filters,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeSchedule);